export interface MenuPermission {
  menuId: number;
  route: string;
  labelKey: string;
  icon: string;
}

export interface NotificationPermission {
  type: 'email' | 'push';
  menuId: number;
  labelKey: string;
}

export const ADMIN_MENU_ROUTE_MAPPINGS: MenuPermission[] = [
  { menuId: 1, route: '/users', labelKey: 'navbar.users', icon: 'group' },
  { menuId: 2, route: '/users/new', labelKey: 'navbar.users', icon: 'group' },
  { menuId: 3, route: '/users/:id', labelKey: 'navbar.users', icon: 'group' },
  { menuId: 4, route: '/notifications', labelKey: 'navbar.notifications', icon: 'notifications' },
  { menuId: 7, route: '/metrics', labelKey: 'navbar.metrics', icon: 'analytics' },
];

export const NOTIFICATION_TYPE_PERMISSIONS: NotificationPermission[] = [
  { type: 'email', menuId: 5, labelKey: 'notifications.email' },
  { type: 'push', menuId: 6, labelKey: 'notifications.push' },
];

export const MENU_IDS = {
  USERS_VIEW: 1,
  USERS_CREATE: 2,
  USERS_DETAIL: 3,
  NOTIFICATIONS_VIEW: 4,
  NOTIFICATIONS_EMAIL: 5,
  NOTIFICATIONS_PUSH: 6,
  METRICS_VIEW: 7,
};
